export default __webpack_public_path__ + "static/media/empty.0d0ec003.png";